import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./config.json'); // eslint-disable-line global-require
}

/**
 * ConfigApi class.
 */
export default class ConfigApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.config;
    }

    /**
     * Get Application Config
     * @returns {promise}
     */
    getConfig() {
        return this.$http.get(this.config.url).then(response => response.data);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/config/config.service.js